import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography, Container } from '@mui/material';
import useLocales from 'hooks/useLocales';
import Image from 'components/image/Image';
import { useTenantInfo } from 'hooks/useTenantInfo';

import './Index.scss';

const NotFound = () => {
  const { t } = useLocales();
  const { tenantLogo } = useTenantInfo();

  return (
    <div className="not-found-page__container">
      <div className="not-found-page__card">
        <div className="not-found-page__card-content">
          <div className="not-found-page__logo">
            {tenantLogo ? (
                <Image url={tenantLogo} width={180} height={80} />
            ) : (
              <Image name="new-rec-logos.svg" width={60} height={60} />
            )}
          </div>
          
          <h1 className="not-found-page__title">
            {t('Sorry, page not found!')}
          </h1>
          
          <p className="not-found-page__message">
            {t("Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling.")}
          </p>

          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            className="not-found-page__button"
          >
            {t('Go to Home')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
